import * as React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization, ISupportedLanguage } from "../../../models/localization";
import { ScreenMode } from "../../../models/enums";
import { Auth } from "../../../utils/auth";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, withMobileDialog } from "material-ui/Dialog";
import Input, { InputLabel } from "material-ui/Input";
import TextField from "material-ui/TextField";
import List, { ListItem, ListItemAvatar, ListItemText } from 'material-ui/List';

@observer
export default class LanguageDlg extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  @action setLanguage = (lang: string): void => {
    if (this.props.store.localization.language != lang) {
      this.props.store.localization.language = lang;
    }      
   this.props.store.viewState.closeLanguages();
   
  }

  @action closeDialog = (): void => {
    this.props.store.viewState.closeLanguages();
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const langs: JSX.Element[] = [];
    local.nav.languages.map((l: ISupportedLanguage, i: number): void => {
      langs.push(<ListItem button onClick={() => this.setLanguage(l.value)} key={i}>
        <ListItemText primary={l.name} />
      </ListItem>);
    });
    return <div>
      <Dialog open={this.props.store.viewState.showLanguages}
        onBackdropClick={() => this.closeDialog()}
        fullScreen={mode === ScreenMode.Mobile} >
        <DialogTitle id="simple-dialog-title">{local.nav.languagesPrompt}</DialogTitle>
        <div>
          <List>        
            {langs}
          </List>
        </div>
      </Dialog>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/language/index.tsx